import { URL_SRV_RAIZ } from "../router/Url";


export const CrudUserFracttal = async (data,A) => {
  // console.log(data,A)

  return new Promise(async (resolve, reject) => {
    let query = await fetch(URL_SRV_RAIZ+'crud_user_fractal',{//'getuser_fracttal',{
      method: "POST",
      headers: {
        'authorization': "marcuxo",
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        DATA: data,
        ACTION:A.ACTION
      })
    })

    let responsito = await query.json();
    if(responsito.success){
      // console.log(responsito);
      resolve(responsito.body)
    }else{
      resolve(responsito.success)
    }
  })
 
}
